(ns app.front.view.admin.migration.migrate-clerks-to-meeting-coordinators
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/migrate-clerks-to-meeting-coordinators
    :title     "Migrate clerk users to meeting coordinator groups"
    :help-text (str "This migration adds all clerk users from authority groups to the meeting coordinator "
                    "group under the parent domain group. Users will be added to the meeting coordinator "
                    "group while remaining in their original clerk groups. This gives clerks domain-wide "
                    "meeting coordination capabilities.")}
   match])

(def route
  {:name        :view/admin.migration.migrate-clerks-to-meeting-coordinators
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/migrate-clerks-to-meeting-coordinators]))}]})
